import * as types from './actionTypes';
import CartService from '../services/CartService';
import * as CartStatusNotifications from "../resources/CartStatusNotification";
import PricingHelper from "../helpers/PricingHelper";

export function AddItemToCart(item, localized, callback) {
    if (PricingHelper.isItemConfigured(item.product)) {
        CartService.addToCartCallback(CartStatusNotifications.ConfiguredItemsNotAvailable, localized);
        return ItemCouldNotBeAddedToCart();
    }
    if (PricingHelper.isItemObsolete(item.product)) {
        CartService.addToCartCallback(CartStatusNotifications.ObsoleteItemsNotAvailable, localized);
        return ItemCouldNotBeAddedToCart();
    } 
      return async function (dispatch) {
        try {
            const response = await CartService.add(item);
            const responseData = await response.json();
            const updatedItem = { ...item, id: responseData.id };
            dispatch(ItemAddedToCart(updatedItem));
            CartService.addToCartCallback(CartStatusNotifications.OrderUpdated, localized);
            if (callback) {
                callback();
            }
        } catch {
            CartService.addToCartCallback(CartStatusNotifications.UnableToAddToCart, localized);
        }
    };
}

export function ItemAddedToCart(item) {
    return {
        type: types.ADD_ITEM, item: item
    };
}

export function UpdateCartItem(item) {
    return {
        type: types.UPDATE_ITEM, item: item
    };
}

export function UpdateAllCartItems(items) {
    return {
        type: types.UPDATE_ALL_ITEMS, items: items
    };
}
export function AddImportCartItems(items) {
    return {
        type: types.IMPORT_CART_ITEMS, items: items
    };
}

export function RemoveCartItem(id, callback) {
    return function (dispatch) {
        CartService.remove(id)
            .then(() => {
                dispatch(ItemRemovedFromCart(id));
            })
            .then(callback);
    };
}
export function ItemRemovedFromCart(id) {
    return {
        type: types.REMOVE_ITEM, id: id
    };
}

export function OrderLoaded(item) {
    return {
        type: types.ORDER_LOADED, item: item
    };
}
export function ClearCart(userId, paymentTerms, paymentInstrument, freightHandlingCode, callback) {
    return async function (dispatch) {
        await CartService.clear(userId);
        dispatch(CartCleared(paymentTerms, paymentInstrument, freightHandlingCode));
        if (typeof callback === 'function') {
            callback();
        }
    };
}
export function CartCleared(paymentTerms, paymentInstrument, freightHandlingCode, selectedBranch = null) {
    return {
        type: types.CLEAR_CART,
        item: { paymentTerms, paymentInstrument, freightHandlingCode, selectedBranch }
    };
}

export function UpdateOrderHeader(freightHandlingCode, requestDate, paymentTerm, selectedBranch) {
    const item = {
        freightHandlingCode,
        requestDate,
        selectedBranch,
      };
      if (paymentTerm && String(paymentTerm.paymentTermId ?? "").trim() !== "") {
            item.paymentTerms = paymentTerm;
          }
  return { type: types.UPDATE_ORDER_HEADER, item };
}


export function UpdatePaymentTerms(paymentTerm) {
    return {
        type: types.UPDATE_PAYMENT_TERMS, item: { paymentTerms: paymentTerm }
    };
}

export function UpdateOrderReview(orderReviewFields) {
   return {
        type: types.UPDATE_ORDER_REVIEW, item: orderReviewFields
    };
}

export function FetchPricing(id) {
    return {
        type: types.FETCH_PRICE, item: { id: id, type: "add" }
    };
}

export function ClearAllFetching() {
    return {
        type: types.CLEAR_FETCHING
    };
}

export function ItemCouldNotBeAddedToCart() {
    return {
        type: types.ITEM_CANNOT_BE_ADDED_TO_CART
    };
}

export function UpdateDropshipAddress(dropshipAddress) {
    return {
        type: types.DROPSHIP_UPDATED, item: dropshipAddress
    };
}
export function UpdateRepriceMessageDisplayed(repricevalue) {
    return {
        type: types.UPDATE_REPRICE_MESSAGE_DISPLAYED, repricevalue: repricevalue
    };
}
export function UpdateWorkdayCalendarSettings(workdayCalendarSettings) {
    return {
        type: types.UPDATE_WORKDAY_CALENDAR_SETTINGS,
        item: {
            workdayCalendarSettings: workdayCalendarSettings,
        },
    };
}